module.exports = __webpack_public_path__ + "img/gywmLOGO.8b382db1.png";